import app from 'app';
import ready from 'utils/ready';

import articlePage from './article/main';

app.add({
  articlePage,
});

ready(app.mount);
